var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.showDeepSteps
        ? _c("deep-steps", {
            attrs: {
              steps: _vm.message.deep_steps,
              label: _vm.strings.investigationSteps,
              live: _vm.streaming,
            },
          })
        : _vm.showSteps
        ? _c("steps-collapsible", {
            attrs: {
              steps: _vm.message.steps,
              label: _vm.strings.analysisSteps,
            },
          })
        : _vm.showGroundingMarker
        ? _c("grounding-marker", {
            attrs: { grounding: _vm.message.grounding, strings: _vm.strings },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "chat-message",
          class: _vm.isUser ? "is-user" : "is-ai",
        },
        [
          _c("div", { staticClass: "bubble-avatar" }, [
            _c("i", { class: _vm.isUser ? "fas fa-user" : "fas fa-comments" }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "bubble-col",
              class: {
                "is-wide": _vm.message.deep,
                "has-artifacts": _vm.hasArtifacts,
              },
            },
            [
              _vm.isUser
                ? _c(
                    "div",
                    {
                      staticClass: "bubble",
                      staticStyle: { "white-space": "pre-wrap" },
                    },
                    [_vm._v(_vm._s(_vm.message.content))]
                  )
                : _c(
                    "div",
                    { staticClass: "bubble" },
                    [
                      _vm._l(_vm.renderedSegments, function (segment) {
                        return [
                          segment.kind === "html"
                            ? _c("div", {
                                key: segment.key,
                                domProps: { innerHTML: _vm._s(segment.html) },
                              })
                            : segment.kind === "chart"
                            ? _c("chart-block", {
                                key: segment.key,
                                attrs: {
                                  spec: segment.spec,
                                  "error-text": _vm.strings.chartRenderError,
                                },
                              })
                            : segment.kind === "map"
                            ? _c("map-block", {
                                key: segment.key,
                                attrs: {
                                  spec: segment.spec,
                                  "error-text": _vm.strings.mapRenderError,
                                  "no-points-text": _vm.strings.mapNoPoints,
                                  "map-config": _vm.mapConfig,
                                },
                              })
                            : segment.kind === "artifact"
                            ? _c("artifact-block", {
                                key: segment.key,
                                attrs: {
                                  spec: segment.spec,
                                  "session-id": _vm.sessionId,
                                  "url-template": _vm.artifactUrlTemplate,
                                  strings: _vm.strings,
                                  "map-config": _vm.mapConfig,
                                },
                              })
                            : _c("mermaid-block", {
                                key: segment.key,
                                attrs: {
                                  spec: segment.spec,
                                  "error-text": _vm.strings.diagramRenderError,
                                },
                              }),
                        ]
                      }),
                    ],
                    2
                  ),
              _vm._v(" "),
              !_vm.isUser && !_vm.streaming
                ? [
                    _vm.message.loop_stopped
                      ? _c("div", { staticClass: "deep-notice" }, [
                          _c("i", {
                            staticClass: "fas fa-exclamation-triangle",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.strings.investigationLoopStopped) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.truncated
                      ? _c("div", { staticClass: "deep-notice" }, [
                          _c("i", {
                            staticClass: "fas fa-exclamation-triangle",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.strings.answerTruncated) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.plan && _vm.message.plan.steps
                      ? _c("div", { staticClass: "plan-card" }, [
                          _c("div", { staticClass: "plan-card-header" }, [
                            _c("i", { staticClass: "fas fa-clipboard-list" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.strings.proposedPlan) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ol",
                            _vm._l(
                              _vm.message.plan.steps,
                              function (step, index) {
                                return _c("li", { key: index }, [
                                  _vm._v(_vm._s(step)),
                                ])
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _vm.isLast && _vm.canApprove
                            ? _c("div", { staticClass: "plan-card-actions" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button is-small is-primary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("approve-plan")
                                      },
                                    },
                                  },
                                  [
                                    _vm._m(0),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.strings.approve)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "plan-card-hint" }, [
                                  _vm._v(_vm._s(_vm.strings.approveHint)),
                                ]),
                              ])
                            : _vm._e(),
                        ])
                      : _vm.message.needs_input && _vm.isLast
                      ? _c("div", { staticClass: "deep-notice is-info" }, [
                          _c("i", { staticClass: "fas fa-question-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.strings.waitingForReply) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.was_cancelled
                      ? _c("div", { staticClass: "deep-notice" }, [
                          _c("i", { staticClass: "fas fa-stop-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.strings.investigationStopped) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.streaming
                ? _c(
                    "div",
                    { staticClass: "bubble-meta" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "bubble-copy-btn",
                          class: _vm.copyState,
                          attrs: { type: "button", title: _vm.strings.copy },
                          on: { click: _vm.copy },
                        },
                        [_c("i", { class: _vm.copyIconClass })]
                      ),
                      _vm._v(" "),
                      !_vm.isUser && _vm.message.chat_log_id
                        ? [
                            _c(
                              "button",
                              {
                                staticClass: "bubble-rate-btn rate-up",
                                class: {
                                  "is-active": _vm.visualRating === "up",
                                  "is-rate-hidden":
                                    _vm.locked && _vm.lockedRating !== "up",
                                },
                                attrs: {
                                  type: "button",
                                  disabled: _vm.locked,
                                  title: _vm.strings.rateThisAnswer,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.openRatingForm("up")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  class:
                                    _vm.visualRating === "up"
                                      ? "fas fa-thumbs-up"
                                      : "far fa-thumbs-up",
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "bubble-rate-btn rate-down",
                                class: {
                                  "is-active": _vm.visualRating === "down",
                                  "is-rate-hidden":
                                    _vm.locked && _vm.lockedRating !== "down",
                                },
                                attrs: {
                                  type: "button",
                                  disabled: _vm.locked,
                                  title: _vm.strings.rateThisAnswer,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.openRatingForm("down")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  class:
                                    _vm.visualRating === "down"
                                      ? "fas fa-thumbs-down"
                                      : "far fa-thumbs-down",
                                }),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "message-timestamp" }, [
                        _vm._v(_vm._s(_vm.relativeTime)),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.streaming && !_vm.isUser && _vm.message.chat_log_id
                ? _c(
                    "div",
                    {
                      ref: "ratingForm",
                      staticClass: "rating-comment-form",
                      class: { "is-hidden": !_vm.ratingFormOpen },
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ratingComment,
                            expression: "ratingComment",
                          },
                        ],
                        staticClass: "rating-comment-input",
                        attrs: {
                          rows: "3",
                          placeholder: _vm.strings.addComment,
                        },
                        domProps: { value: _vm.ratingComment },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.ratingComment = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "rating-comment-submit",
                          attrs: {
                            type: "button",
                            disabled: _vm.ratingSubmitting,
                          },
                          on: { click: _vm.submitRating },
                        },
                        [_c("i", { staticClass: "fas fa-paper-plane" })]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }